import getFromDataLayer from './getFromDataLayer';
import { getCookie } from '../utilities/cookie';

export const trackAddPropertyToBasketEvent = (target: HTMLElement) => {
  const rateCard = target.closest('.card, .ratecard') as HTMLElement;

  if (!rateCard) return;
    const {
        currency,
        extras,
        rateId,
        rateName,
        isOffer
    } = rateCard.dataset;

    const getPriceValue = (selector: string) => {
        const el = rateCard.querySelector(selector);

        if (!el) return null;

        const text = (el.textContent && el.textContent.trim()) || "";
        const num = parseFloat(text.replace(/[^\d.-]/g, ""));

        return isNaN(num) ? null : num;
    };

    const payUsNowValue = getPriceValue('.deposit .price, .payUsNow span');
    const totalPriceValue = getPriceValue('.price-box .main, .totalPrice span');
    const totalAdditionalFeesValue = getPriceValue('.additional-fees span, .totalAdditionalFees span');

    const user = getFromDataLayer(window.dataLayer, 'user');
    const {search} = getFromDataLayer(window.dataLayer, 'pageDetails');
    const {
        startDate,
        endDate,
    } = search;

    const searchDetails = getCookie('smithsites_search');
    const searchBar = searchDetails ? JSON.parse(searchDetails) : '';

    const eventData = {
        startDate,
        endDate,
        totalPrice: totalPriceValue,
        priceToPayNow: payUsNowValue,
        feesAndTaxes: totalAdditionalFeesValue,
        currency,
        extras: Number(extras),
        adultOccupancy: (searchBar && searchBar.adults) || 'n/a',
        childOccupancy: (searchBar && searchBar.child) || 'n/a',
        childAges: (searchBar && searchBar.child_ages) ? searchBar.child_ages.join(',') : '',
        propertyId: getFromDataLayer(window.dataLayer, 'property_id'),
        propertyName: getFromDataLayer(window.dataLayer, 'property_name'),
        propertyLocation: getFromDataLayer(window.dataLayer, 'property_location'),
        rateId: rateId,
        rateName,
        isOffer: isOffer === "1", 
        loggedIn: user && user.loggedIn,
        memberId: user && user.memberId || null
    }

    window.dataLayer.push({
        event: 'add_to_cart_button_click',
        ...eventData
    });
}

export const trackAddProductToBasketEvent = (target: HTMLElement) => {
    const form = target.closest('form');
    const formData = new FormData(form);

    const currency = formData.get('product[currencies]');
    const priceId = formData.get('product[prices]');
    const quantity = formData.get('product[quantity]');
    const planId = formData.get("product_membership[plans]");
    
    const priceIdElement = document.querySelector(`option[value="${priceId}"]`);
    const price = !!priceId && priceIdElement && priceIdElement.textContent;

    const planIdElement = document.querySelector(`option[value="${planId}"]`);
    const planName = !!planId && planIdElement && planIdElement.textContent;

    const user = getFromDataLayer(window.dataLayer, 'user');

    const {productId, productName} = document.getElementById('shop-product').dataset;

    const eventData = {
        totalPrice: price ? Number(price): null,
        currency: currency || null,
        quantity: quantity ? Number(quantity) : null,
        productId,
        productName,
        planId,
        planName,
        loggedIn: user && user.loggedIn,
        memberId: user && user.memberId || null
    }

    window.dataLayer.push({
        event: 'add_to_cart_button_click',
        ...eventData
    });
}

export default {
    trackAddPropertyToBasketEvent,
    trackAddProductToBasketEvent
}